/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {
  IntegrationControllerDownloadAirStickerClientIdPath,
  IntegrationControllerDownloadFinalInspectionReportClientIdPath,
  IntegrationControllerDownloadFivClientIdPath,
  IntegrationControllerDownloadImmatriculationClientIdPath,
  IntegrationControllerDownloadInspectionReportClientIdPath,
  IntegrationControllerDownloadInsuranceCertificateClientIdPath,
  IntegrationControllerDownloadSafetyInspectionClientIdPath,
  IntegrationControllerGetCarClientIdPath,
  IntegrationControllerGetCarContractIdPath,
  IntegrationControllerGetCarRentalPeriodIdPath,
  IntegrationControllerGetContractClientIdPath,
  IntegrationControllerGetContractContractIdPath,
  IntegrationControllerListCarsToDeliverClientIdPath,
  IntegrationControllerListInvoicesClientIdPath,
  IntegrationControllerViewCarPictureClientIdPath
} from '../models';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IntegrationApi {

  /**
   * Affiche la photo d'un modèle de véhicule.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static viewCarPicture({
    id,
    clientId,
  }: {
    id: string,
    clientId: IntegrationControllerViewCarPictureClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/car-models/{id}/pictures',
      path: {
        'id': id,
        'clientId': clientId,
      },
      responseMediaType: [
        'image/png',
      ],
    });
  }

  /**
   * Télécharge le certificat d'immatriculation d'un véhicule au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadImmatriculation({
    carId,
    clientId,
  }: {
    carId: string,
    clientId: IntegrationControllerDownloadImmatriculationClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/cars/{carId}/immatriculation',
      path: {
        'carId': carId,
        'clientId': clientId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge l'attestation d'assurance d'un véhicule au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadInsuranceCertificate({
    carId,
    vin,
    clientId,
  }: {
    carId: string,
    vin: string,
    clientId: IntegrationControllerDownloadInsuranceCertificateClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/cars/{carId}/insurance-certificate/{vin}',
      path: {
        'carId': carId,
        'vin': vin,
        'clientId': clientId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge le rapport d'inspection de livraison au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadInspectionReport({
    rentalPeriodId,
    clientId,
  }: {
    rentalPeriodId: string,
    clientId: IntegrationControllerDownloadInspectionReportClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/cars/inspection-report/{rentalPeriodId}',
      path: {
        'rentalPeriodId': rentalPeriodId,
        'clientId': clientId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge le rapport d'inspection de restitution au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadFinalInspectionReport({
    rentalPeriodId,
    clientId,
  }: {
    rentalPeriodId: string,
    clientId: IntegrationControllerDownloadFinalInspectionReportClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/cars/final-inspection-report/{rentalPeriodId}',
      path: {
        'rentalPeriodId': rentalPeriodId,
        'clientId': clientId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge le bon de commande au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadOrder({
    clientId,
    orderId,
  }: {
    clientId: string,
    orderId: string,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/orders/{orderId}',
      path: {
        'clientId': clientId,
        'orderId': orderId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge un avenant de contrat au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadAmendment({
    clientId,
    amendmentId,
  }: {
    clientId: string,
    amendmentId: string,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/amendments/{amendmentId}',
      path: {
        'clientId': clientId,
        'amendmentId': amendmentId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge une facture au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadInvoice({
    clientId,
    invoiceId,
  }: {
    clientId: string,
    invoiceId: string,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/invoices/{invoiceId}',
      path: {
        'clientId': clientId,
        'invoiceId': invoiceId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge la vignette Crit'Air provisoire au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadAirSticker({
    carId,
    clientId,
  }: {
    carId: string,
    clientId: IntegrationControllerDownloadAirStickerClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/air-stickers/{carId}',
      path: {
        'carId': carId,
        'clientId': clientId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge la fiche d'identification du véhicule au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadFiv({
    carId,
    clientId,
  }: {
    carId: string,
    clientId: IntegrationControllerDownloadFivClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/cars/{carId}/fiv',
      path: {
        'carId': carId,
        'clientId': clientId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Télécharge le contrôle technique d'un véhicule au format PDF.
   * @returns binary Successful response
   * @throws ApiError
   */
  public static downloadSafetyInspection({
    carId,
    clientId,
  }: {
    carId: string,
    clientId: IntegrationControllerDownloadSafetyInspectionClientIdPath,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/cars/{carId}/safety-inspection',
      path: {
        'carId': carId,
        'clientId': clientId,
      },
      responseMediaType: [
        'application/pdf',
      ],
    });
  }

  /**
   * Récupère les informations d'un véhicule pour une période de location.
   * @returns void
   * @throws ApiError
   */
  public static getCar({
    clientId,
    contractId,
    rentalPeriodId,
  }: {
    clientId: IntegrationControllerGetCarClientIdPath,
    contractId: IntegrationControllerGetCarContractIdPath,
    rentalPeriodId: IntegrationControllerGetCarRentalPeriodIdPath,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/contracts/{contractId}/rental-periods/{rentalPeriodId}',
      path: {
        'clientId': clientId,
        'contractId': contractId,
        'rentalPeriodId': rentalPeriodId,
      },
    });
  }

  /**
   * Récupère le détail d'un contrat de location.
   * @returns void
   * @throws ApiError
   */
  public static getContract({
    clientId,
    contractId,
  }: {
    clientId: IntegrationControllerGetContractClientIdPath,
    contractId: IntegrationControllerGetContractContractIdPath,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/contracts/{contractId}',
      path: {
        'clientId': clientId,
        'contractId': contractId,
      },
    });
  }

  /**
   * Liste les véhicules à livrer.
   * @returns void
   * @throws ApiError
   */
  public static listCarsToDeliver({
    clientId,
  }: {
    clientId: IntegrationControllerListCarsToDeliverClientIdPath,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/to-deliver',
      path: {
        'clientId': clientId,
      },
    });
  }

  /**
   * Liste les factures du client.
   * @returns void
   * @throws ApiError
   */
  public static listInvoices({
    clientId,
  }: {
    clientId: IntegrationControllerListInvoicesClientIdPath,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/clients/{clientId}/invoices',
      path: {
        'clientId': clientId,
      },
    });
  }

}
